import { Component, computed, effect, inject, input, model, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { faCalendar, faClock, faHome } from '@fortawesome/pro-regular-svg-icons';
import {
  ButtonComponent,
  PanelComponent,
  PanelGroupComponent,
  PanelGroupItem,
  PanelTemplateType,
  PfxTemplateDirective,
} from '@pflegix/ui';
import { TaskCreateSidebarComponent } from '../../task-create-sidebar/component/task-create-sidebar.component';
import { TaskDetailsSidebarComponent } from '../../task-details-sidebar';
import { TaskNotesWidgetComponent } from '../../task-list-widget-notes';
import { TaskListWidgetStore } from '../store/task-list-widget.store';

@Component({
  selector: 'pfx-task-list-widget',
  imports: [
    PanelComponent,
    PanelGroupComponent,
    ButtonComponent,
    TaskDetailsSidebarComponent,
    TaskCreateSidebarComponent,
    TaskNotesWidgetComponent,
    PfxTemplateDirective,
    RouterLink,
  ],
  providers: [TaskListWidgetStore],
  templateUrl: './task-list-widget.component.html',
})
export class TaskListWidgetComponent {
  public filter = input.required<string>();

  public url = input.required<string>();

  protected PanelTemplateType = PanelTemplateType;

  protected faHome = faHome;

  protected faClock = faClock;

  protected faCalendar = faCalendar;

  protected selectedPanelItem = signal<PanelGroupItem | undefined>(undefined);

  protected isCreateSidebarVisible = model(false);

  protected selectedTaskId = computed(() => this.selectedPanelItem()?.id);

  protected panelTitle = computed<string>(() => `Offene Aufgaben (${this.taskListWidgetStore.totalDocs()})`);

  protected isDetailsSidebarOpen = computed<boolean>(() => !!this.selectedTaskId());

  protected taskListWidgetStore = inject(TaskListWidgetStore);

  constructor() {
    // Use effects to automatically update store when filter input changes
    effect(() => {
      const filter = this.filter();

      this.taskListWidgetStore.setGetFilter(filter);
      this.taskListWidgetStore.getTasks(filter);
    });
  }

  protected handlePanelItemClicked(panelGroupItem: PanelGroupItem): void {
    this.selectedPanelItem.set(panelGroupItem);
  }

  protected handleVisibleChanged(isVisible: boolean): void {
    if (isVisible) {
      return;
    }

    this.selectedPanelItem.set(undefined);
  }

  protected toggleCreateSidebar(): void {
    this.isCreateSidebarVisible.set(!this.isCreateSidebarVisible());
  }
}
